// @ts-nocheck
import { Component } from '@theme/component';


const css = /* css */`
.cart-items__subscription-info {
  position: relative;
  width: 120px;
  display: flex;
  align-items: center;
  gap: 7px;
  margin-bottom: 10px;
  text-transform: uppercase;
}

.cart-items__subscription-popup-button {
  color: #fff;
  border: 1px solid #fff;
  background-color: transparent;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  --length: 20px;
  min-width: var(--length);
  max-width: var(--length);
  min-height: var(--length);
  max-height: var(--length);
  cursor: pointer;
}

.cart-items__subscription-popup-message {
  display: none;
  position: absolute;
  bottom: 0;
  left: 0;
  transform: translate(0, 115%);
  z-index: 2;
  background-color: #fff;
  color: #000;
  padding: 20px;
  width: 300px;
  height: max-content;
  font-size: 16px;
  line-height: 1.6;
  text-align: left;
  text-wrap: balance;
  box-shadow: 0 0 20px 5px #0002;
  user-select: none;
}

.cart-items__subscription-popup-button.show .cart-items__subscription-popup-message {
  display: block;
}
`;


class CartItemSubscriptionTextPopup extends Component {     
  static observedAttributes = ['data-item-key', 'data-subscription-pct'];

  itemKey = '';
  productHandle = '';
  variantId = NaN;
  subscriptionPct = 0;

  constructor() {
    super();
    this.shadow = this.attachShadow({ mode: "open" });
    this.shadow.addEventListener('click', this.handlePopupClick.bind(this));
  }


  connectedCallback() {
    super.connectedCallback();
    this.itemKey = this.getAttribute('data-item-key') || '';
    this.productHandle = this.getAttribute('data-product-handle') || '';
    this.variantId = parseInt(this.getAttribute('data-variant-id')) || NaN;
    this.render();
  }


  disconnectedCallback() {
    super.disconnectedCallback();
    this.shadow.removeEventListener('click', this.handlePopupClick.bind(this));
  }      


  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-item-key') this.itemKey = newValue;
    if (name === 'data-product-handle') this.productHandle = newValue;
    if (name === 'data-variant-id') this.variantId = parseInt(newValue) || NaN;
    if (name === 'data-subscription-pct') this.subscriptionPct = parseInt(newValue) || 0;
    this.render();
  }


  handlePopupClick(/** @type {MouseEvent} */ e) {
    e.preventDefault();
    e.stopPropagation();

    const selector = `.cart-items__subscription-popup-button[data-variant-id="${ this.variantId }"]`;
    const popupButton = this.shadow.querySelector(selector);

    const allPopupButtonEls = document.querySelectorAll('cart-item-subscription-text-popup');
    allPopupButtonEls.forEach((btn) => {      
      if (btn.dataset.itemKey === this.dataset.itemKey) return;
      const buttonEl = btn.shadow.querySelector('.cart-items__subscription-popup-button');
      buttonEl.classList.remove('show');
    });

    if (!popupButton.contains(e.target)) return;

    popupButton.classList.toggle('show');
    if (popupButton.classList.contains('show')) {
      document.addEventListener('click', () => popupButton.classList.remove('show'), { once: true})
    }
  }         
  
  
  render() {
    this.shadow.innerHTML = /* html */`
      <style>${css}</style>
      <p class="cart-items__subscription-info">
        Subscription
        <button
          class="cart-items__subscription-popup-button"
          data-variant-id="${ this.variantId }"
        >
          <span>?</span>
          <p class="cart-items__subscription-popup-message">
            Get ${this.subscriptionPct}% off when you subscribe. Pick your own delivery schedule.
            Mix it up, skip or cancel anytime - no strings attached.
          </p>
        </button>
      </p>
    `;
  }
}

if (!customElements.get('cart-item-subscription-text-popup')) {
  customElements.define('cart-item-subscription-text-popup', CartItemSubscriptionTextPopup);
}                   







